import {useEffect, useState} from 'react';
import {useUserApi} from '../api/user';

const enablePrivateAccess = true;

/**
 * Component to control access to the demographic page based on user data.
 *
 * @param {Object} props - React props containing the element to be rendered.
 * @param {JSX.Element} props.element - The JSX element to be rendered if access is granted.
 * @returns {JSX.Element} The JSX element for controlling demographic page access.
 */
export const DemographicPageAccess = ({element}) => {
  const [renderElement, setRenderElement] = useState(null);
  const userApi = useUserApi();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!enablePrivateAccess) {
          setRenderElement(element);
          return;
        }
        const userDataReq = await userApi.getUserData();
        if (
          userDataReq.data.email !== '' &&
          (userDataReq.data.is_email_verified === false || userDataReq.data.is_email_verified === null)
        ) {
          return;
        }
        setRenderElement(element);
      } catch {
        // TODO: Handle error
      }
    };
    fetchData();
  }, [element, userApi]);

  // Render the element conditionally
  return renderElement;
};
